import "./error.scss";
import { type FC } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button";

const DefaultError: FC = () => {
    const navigate = useNavigate();

    return (
        <div className="error error-default">
            <div className="title">
                Error
            </div>
            <div className="subheading">
                An error occurred
            </div>
            <div className="buttons">
                <Button
                    onClick={() => {
                        if(history.length !== 1) {
                            navigate(-1);
                        } else {
                            navigate("/");
                        }
                    }}
                    classes={[ "secondary-button" ]}
                >
                    Back
                </Button>
                <Button
                    onClick={() => {
                        navigate("/");
                    }}
                    classes={[ "primary-button" ]}
                >
                    Home
                </Button>
            </div>
        </div>
    );
};

export default DefaultError;
